import React from 'react'
import Widget from '../../Widget'
import WidgetTitle from '../WidgetTitle'
import WidgetBody from './WidgetBody'
import WidgetFooter from './WidgetFooter'

const AccountsOverviewWidget: React.FC = () => {
  return (
    <Widget
      widgetTitle={<WidgetTitle title="Accounts Overview" />}
      widgetAriaLabel="A summary of your bank and investment accounts in a pie chart."
      widgetBody={<WidgetBody />}
      dataTestId="account-overview-widget"
      footer={<WidgetFooter />}
    />
  )
}

export default AccountsOverviewWidget
